import React from 'react';
import { connect } from 'react-redux';
import { IconButton } from 'react-toolbox/lib/button';
import Tag from '~/components/Tag';
import Spinner from '~/components/Spinner';
import styleDialog from '~/style/dialog.scss';
import { list } from '~/actions/actions';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    list(this.props.dispatch, this.context.apiClient)
      .then(() => this.setState({ loading: false }));
  }

  render() {
    const results = Object.values(this.props.items);
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <div>Pick an action</div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {!this.state.loading && results.length === 0 && <div>No actions found</div>}
              {this.state.loading && <Spinner />}
            </div>
            <div style={{ overflow: 'auto', maxHeight: '50vh' }}>
              {!this.state.loading && results.map(i => (<div key={i.id} style={{ margin: '5px 0px 0px 0px' }}>
                <Tag
                  id={i.id}
                  type="action"
                  onClick={() => {
                    this.props.data.onChange(i.id);
                    this.context.dialogClose(this.props.dialogId);
                  }}
                />
              </div>))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  items: state.getIn(['actions', 'items']).toJS(),
});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/ActionPick/index.js